export class ContentLocker {
    lockerId?: number;
    /**
     * General
     */
    lockerName?: string;
    lockerLeads?: number;
    lockerUnlock?: number;
    lockerUnlocklink?: string;

    /**
     * Overlay
     */
    overlayColor?: string;
    overlayOpacity?: string;

    /**
    * Main frame
    */
    mainFrameFont?: string;
    mainFrameWidth?: number;
    mainFrameMinHeight?: number;
    mainFrameBackgroundColor?: string;
    mainFrameBorderSize?: number;
    mainFrameBorderColor?: string;
    /**
     * Header
     */
    h1Text?: string;
    h1TextAlign?: string;
    h1Width?: number;
    h1MarginTop?: number;
    h1FontColor?: string;
    h1FontSize?: number;
    h1FontWeight?: number;
    /**
     * Subheader
     */
    h2Text?: string;
    h2TextAlign?: string;
    h2Width?: number;
    h2MarginTop?: number;
    h2FontColor?: string;
    h2FontSize?: number;
    h2FontWeight?: number;
    /**
     * Offers table
     */
    offersNumbers?: number;
    offersTableWidth?: number;
    offersTableMargin?: number;
    offersTablePadding?: number;
    offersTableBorderSize?: number;
    offersTableBorderColor?: string;
    offerLineHeight?: number;
    offerLinePadding?: number;
    offerTextAlign?: string;
    offerLinkDecoration?: string;
    offerLinkColor?: string;
    offerLinkHoverColor?: string;
    offerLinkFontSize?: number;
    offerEvenBackgroundColor?: string;
    offerEvenBackgroundColorOpacity?: string;

    /**
     * Notice properties
     */
    noticeText?: string;
    noticeTextAlign?: string;
    noticeWidth?: number;
    noticeMarginTop?: number;
    noticeFontColor?: string;
    noticeFontSize?: number;
    noticeFontWeight?: number;
    /**
     * Waiting properties
     */
    waitingText1?: string;
    waitingText2?: string;
    waitingTextAlign?: string;
    waitingWidth?: number;
    waitingMarginTop?: number;
    waitingLinkText?: string;
    waitingFontColor?: string;
    waitingFontSize?: number;
    waitingFontWeight?: number;
}

export class NewContentLocker {
  /**
   * General
   */
  lockerName?: string;
  lockerLeadsInPercent?: number;
  isLockerLeadsOn?: boolean;
  contentLockerUnlockType?: number;
  lockerUnlocklink?: string;

  /**
   * Overlay
   */
  overlayColor?: string;
  overlayOpacity?: number; // BYŁO string

  /**
  * Main frame
  */
  mainFrameFont?: string;
  mainFrameWidth?: number;
  mainFrameMinHeight?: number;
  mainFrameBackgroundColor?: string;
  mainFrameBorderSize?: number;
  mainFrameBorderColor?: string;
  /**
   * Header
   */
  h1Text?: string;
  h1TextAlign?: string;
  h1Width?: number;
  h1MarginTop?: number;
  h1FontColor?: string;
  h1FontSize?: number;
  h1FontWeight?: number;
  /**
   * Subheader
   */
  h2Text?: string;
  h2TextAlign?: string;
  h2Width?: number;
  h2MarginTop?: number;
  h2FontColor?: string;
  h2FontSize?: number;
  h2FontWeight?: number;
  /**
   * Offers table
   */
  offersNumbers?: number;
  offersTableWidth?: number;
  offersTableMargin?: number;
  offersTablePadding?: number;
  offersTableBorderSize?: number;
  offersTableBorderColor?: string;
  offerLineHeight?: number;
  offerLinePadding?: number;
  offerTextAlign?: string;
  offerLinkDecoration?: string;
  offerLinkColor?: string;
  offerLinkHoverColor?: string;
  offerLinkFontSize?: number;
  offerEvenBackgroundColor?: string;
  offerEvenBackgroundColorOpacity?: number; // BYŁO string

  /**
   * Notice properties
   */
  noticeText?: string;
  noticeTextAlign?: string;
  noticeWidth?: number;
  noticeMarginTop?: number;
  noticeFontColor?: string;
  noticeFontSize?: number;
  noticeFontWeight?: number;
  /**
   * Waiting properties
   */
  waitingText1?: string;
  waitingText2?: string;
  waitingTextAlign?: string;
  waitingWidth?: number;
  waitingMarginTop?: number;
  waitingLinkText?: string;
  waitingFontColor?: string;
  waitingFontSize?: number;
  waitingFontWeight?: number;
}

export class FileLocker{
    fileLockerFileName?: string;
    leads?: number;
    alias?: string;
    redirection?: string;
    domain?: any;
}
